import React, { Component } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";
import {
  clearValues,
  setValue,
  focusNext,
  focusPrev,
  focusLeft,
  focusRight,
  focusUp,
  focusDown
} from "../../../reducers/crossword/actions";
import {
  getCell,
  getValue,
  getShowHints,
  hasFocus,
  isCorrect
} from "../../../reducers/crossword/selectors";
import { setFocus } from "../../../reducers/crossword/actions";

const mapStateToProps = (state, { x, y }) => ({
  cell: getCell(state, x, y),
  value: getValue(state, x, y),
  focused: hasFocus(state, x, y),
  hint: getShowHints(state),
  correct: getShowHints(state) && isCorrect(state, x, y)
});

const mapDispatchToProps = dispatch => ({
  clearValues: () => dispatch(clearValues()),
  setFocus: (x, y) => dispatch(setFocus(x, y)),
  setValue: (x, y, value) => dispatch(setValue(x, y, value)),
  focusNext: (x, y) => dispatch(focusNext(x, y)),
  focusPrev: (x, y) => dispatch(focusPrev(x, y)),
  focusLeft: (x, y) => dispatch(focusLeft(x, y)),
  focusRight: (x, y) => dispatch(focusRight(x, y)),
  focusUp: (x, y) => dispatch(focusUp(x, y)),
  focusDown: (x, y) => dispatch(focusDown(x, y))
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
export default class CellContainer extends Component {
  setValue = value => {
    const { x, y, setValue } = this.props;

    setValue(x, y, value);
  };

  move = keyCode => {
    const {
      x,
      y,
      focusNext,
      focusPrev,
      focusLeft,
      focusUp,
      focusRight,
      focusDown
    } = this.props;

    switch (keyCode) {
      case 37:
        ReactGA.event({
          category: "Navigation",
          action: "Keyboard",
          label: "Left"
        });

        focusLeft(x, y);
        break;
      case 38:
        ReactGA.event({
          category: "Navigation",
          action: "Keyboard",
          label: "Up"
        });

        focusUp(x, y);
        break;
      case 39:
        ReactGA.event({
          category: "Navigation",
          action: "Keyboard",
          label: "Right"
        });

        focusRight(x, y);
        break;
      case 40:
        ReactGA.event({
          category: "Navigation",
          action: "Keyboard",
          label: "Down"
        });

        focusDown(x, y);
        break;
      case 8:
        focusPrev(x, y);
        break;
      default:
        focusNext(x, y);
        break;
    }
  };

  setFocus = (focus = true) => {
    const { x, y, setFocus, focused } = this.props;

    if (!focused && focus) {
      setFocus(x, y);
    } else if (focused && !focus) {
      setFocus();
    }
  };

  render = () =>
    React.createElement(this.props.component, {
      ...this.props,
      setValue: this.setValue,
      setFocus: this.setFocus,
      move: this.move
    });
}



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/CellContainer.js